import { atom } from 'recoil'
import { Product } from '../models/contractsModel'
import { PostInquiryData } from '../models/inquiriesModel'

export type SenderType = 'bot' | 'user'
export type MessageItem = {
  sender: SenderType
  messages: string[]
}
/**
 * 保証申請までの手順種別
 * 実際の流れ順になってます
 **/
export type StepType =
  | 'initial' // 初期描画
  | 'inputInquiryCodeOrEmail' //保証番号かアドレスを入力
  | 'fulfilled' //保証履行済みの場合は保証申請出来ない
  | 'inputVerifyCode' //アドレスから送られた認証コードを入力
  | 'notFoundInquiryCodeOrEmail' //アドレス以外が入力後、レスポンスがなかった場合
  | 'chooseProduct' //プロダクト選択
  | 'chooseNaturalFailure' //自然故障か否か
  | 'beforePlanStart' //プロダクトのプラン開始がまだ
  | 'inputDate' //日付入力
  | 'inputOverView' //概要入力
  | 'chooseChangeEmail' //メールを変更するか否か
  | 'inputUpdateEmail' //変更したいメールを入力
  | 'inputUpdatePhone' //変更したい電話番号を入力
  | 'chooseChangeAddress' //住所を変更するか否か
  | 'inputShippingAddress' //変更したい住所を入力
  | 'uploadImage' //故障した商品の状態が分かるように画像をアップロードさせる

export const messageListState = atom<MessageItem[]>({
  key: 'messageList',
  default: [],
})

export const stepState = atom<StepType>({
  key: 'step',
  default: 'initial',
})

export const isInViewFooterState = atom<boolean>({
  key: 'isInView',
  default: false,
})

export const inputState = atom<string>({
  key: 'input',
  default: '',
})

export const inputtedEmailState = atom<string>({
  key: 'inputtedEmail',
  default: '',
})

export const productsState = atom<Product[]>({
  key: 'products',
  default: [],
})

export const selectedProductState = atom<Product>({
  key: 'selectedProduct',
  default: undefined,
})

export const onetimeKeyState = atom<string>({
  key: 'onetimeKey',
  default: '',
})

export const inquiryState = atom<PostInquiryData>({
  key: 'inquiry',
  default: {
    contractId: '',
    description: '',
    failureDate: '',
  },
})

export const filesState = atom<File[]>({
  key: 'files',
  default: [],
})
